// import React, { useState, useEffect } from "react";
// import { Chart } from "react-google-charts";
// import "./index.css";
// import { useGetSalesDataForRestaurantQuery } from "../../redux/services/dashboardService";
// import { useSelector } from "react-redux";
// import { Alert, Card } from "react-bootstrap";

// type ChartDataRow =
//   | string
//   | number
//   | { role: string; type: string }
//   | { v: string; f: string };


// const today = new Date();

// // Function to get the last day of the current month
// const getEndOfMonth = (date: Date): Date => {
//   return new Date(date.getFullYear(), date.getMonth() + 1, 0);
// };

// // Calculate the start date for the timeframe
// const calculateStartDate = (timeFrame: string): string => {
//   const startDate = new Date(today);
//   switch (timeFrame) {
//     case "12 months":
//       startDate.setMonth(today.getMonth() - 11); // Start 11 months ago to include current month
//       startDate.setDate(1); // Set to the first day of the start month
//       break;
//     case "3 months":
//       startDate.setMonth(today.getMonth() - 2);
//       startDate.setDate(1);
//       break;
//     case "30 days":
//       startDate.setDate(today.getDate() - 30);
//       break;
//     case "7 days":
//       startDate.setDate(today.getDate() - 7);
//       break;
//     case "24 hours":
//       startDate.setHours(0, 0, 0, 0);
//       break;
//     default:
//       startDate.setMonth(today.getMonth() - 11);
//       startDate.setDate(1);
//   }
//   return startDate.toISOString();
// };

// // Generate an array of hours from 00:00 to the current hour in ascending order
// const generateHourRange = (now: Date): string[] => {
//   const hourRange: string[] = [];
//   const currentHour = now.getHours();

//   for (let i = 0; i <= currentHour; i++) {
//     const date = new Date(now);
//     date.setHours(i, 0, 0, 0); // Set to the exact hour
//     const hourLabel = date.toLocaleTimeString("default", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: false,
//     });
//     hourRange.push(hourLabel); // e.g., "14:00"
//   }

//   return hourRange;
// };

// // Generate an array of dates for the past 30 days
// const generateDateRange = (days: number): string[] => {
//   const dateRange: string[] = [];
//   for (let i = 0; i < days; i++) {
//     const date = new Date(today);
//     date.setDate(today.getDate() - i);
//     dateRange.unshift(
//       date.toLocaleDateString("default", {
//         day: "numeric",
//         month: "short",
//         year: "numeric",
//       })
//     );
//   }
//   return dateRange;
// };

// // Generate an array of month names for the past 12 months
// const generateMonthNames = (months: number): string[] => {
//   const monthNames: string[] = [];
//   const endMonth = getEndOfMonth(today);
//   for (let i = 0; i < months; i++) {
//     const month = new Date(endMonth.getFullYear(), endMonth.getMonth() - i, 1);
//     monthNames.unshift(
//       month.toLocaleString("default", { month: "long", year: "numeric" })
//     );
//   }
//   return monthNames;
// };

// const Graph = () => {
//   const restaurantId = useSelector(
//     (state: any) => state?.restaurant?.selectedRestaurantDetails?.id || "jdfhfhdf"
//   );

//   const [timeFrame, setTimeFrame] = useState("12 months");
//   const [graphData, setGraphData] = useState<ChartDataRow[][]>([
//     ["Date", "Total Sales"],
//   ]);

//   const now = new Date();

//   // Fetch sales data using RTK query hook
//   const { data, error, isLoading } = useGetSalesDataForRestaurantQuery({
//     restaurantId,
//     startDate: calculateStartDate(timeFrame),
//     endDate: today.toISOString(),
//   });

//   // Effect to handle data transformation
//   useEffect(() => {
//     if (data && data.salesStatList) {
//       let formattedData: ChartDataRow[][] = [];

//       if (timeFrame === "12 months" || timeFrame === "3 months") {
//         // Handle month-based graph
//         const monthsToGenerate = timeFrame === "12 months" ? 12 : 3;
//         const monthNames = generateMonthNames(monthsToGenerate);

//         // Initialize each month with a total of 0
//         const salesByMonth: Record<string, number> = monthNames.reduce(
//           (acc, month) => {
//             acc[month] = 0;
//             return acc;
//           },
//           {} as Record<string, number>
//         );

//         // Group and sum sales data by month
//         data.salesStatList.forEach((sale) => {
//           const saleMonth = new Date(sale.date).toLocaleString("default", {
//             month: "long",
//             year: "numeric",
//           });
//           if (salesByMonth[saleMonth] !== undefined) {
//             salesByMonth[saleMonth] += sale.totalSales;
//           }
//         });

//         // Format the data for the chart
//         formattedData = monthNames.map((month) => [month, salesByMonth[month]]);
//         setGraphData([["Month", "Total Sales"], ...formattedData]);
//       }

//       if (timeFrame === "30 days") {
//         const dateRange = generateDateRange(30); // Individual dates for last 30 days

//         // Initialize each date with a total of 0
//         const salesByDate: Record<string, number> = dateRange.reduce((acc, date) => {
//           acc[date] = 0;
//           return acc;
//         }, {} as Record<string, number>);

//         // Group and sum sales data by day
//         data.salesStatList.forEach((sale) => {
//           const saleDate = new Date(sale.date).toLocaleDateString("default", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//           });
//           if (salesByDate[saleDate] !== undefined) {
//             salesByDate[saleDate] += sale.totalSales;
//           }
//         });

//         // Format the data for the chart
//         formattedData = dateRange.map((date, index) => {
//           const totalSales = salesByDate[date];
//           const showLabel = index % 7 === 0; // Show label only for every 7th day

//           // Create a tooltip content
//           const tooltipContent = `Date: ${date}\nTotal Sales: ${totalSales}`;

//           return [
//             { v: date, f: showLabel ? date : "" },
//             totalSales,
//             tooltipContent
//           ];
//         });

//         setGraphData([
//           ["Date", "Total Sales", { role: "tooltip", type: "string" }],
//           ...formattedData
//         ]);
//       }


//       if (timeFrame === "7 days") {
//         // Handle day-based graph
//         const daysToGenerate = 7;
//         const dateRange = generateDateRange(daysToGenerate);

//         // Initialize each day with a total of 0
//         const salesByDay: Record<string, number> = dateRange.reduce(
//           (acc, date) => {
//             acc[date] = 0;
//             return acc;
//           },
//           {} as Record<string, number>
//         );

//         // Group and sum sales data by day
//         data.salesStatList.forEach((sale) => {
//           const saleDate = new Date(sale.date).toLocaleDateString("default", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//           });
//           if (salesByDay[saleDate] !== undefined) {
//             salesByDay[saleDate] += sale.totalSales;
//           }
//         });

//         // Format the data for the chart
//         formattedData = dateRange.map((date) => [date, salesByDay[date]]);
//         setGraphData([["Date", "Total Sales"], ...formattedData]);
//       }

//       if (timeFrame === "24 hours") {
//         // Handle hour-based graph
//         const hourRange = generateHourRange(now); // Generate hours from 00:00 to current hour

//         // Initialize each hour with a total of 0
//         const salesByHour: Record<string, number> = hourRange.reduce(
//           (acc, hour) => {
//             acc[hour] = 0;
//             return acc;
//           },
//           {} as Record<string, number>
//         );

//         // Group and sum sales data by hour
//         data.salesStatList.forEach((sale) => {
//           const saleDate = new Date(sale.date);
//           const saleHour = saleDate.toLocaleTimeString("default", {
//             hour: "2-digit",
//             minute: "2-digit",
//             hour12: false,
//           });
//           if (salesByHour[saleHour] !== undefined) {
//             salesByHour[saleHour] += sale.totalSales;
//           }
//         });

//         // Format the data for the chart
//         formattedData = hourRange.map((hour) => [hour, salesByHour[hour]]);
//         setGraphData([["Hour", "Total Sales"], ...formattedData]);
//       }
//     }
//   }, [data, timeFrame, now]);

//   // Function to handle filter button click
//   const handleFilterClick = (selectedTimeFrame: string) => {
//     setTimeFrame(selectedTimeFrame);
//   };

//   return (
//     <div>
//       <div className="filter-buttons">
//         <button
//           onClick={() => handleFilterClick("12 months")}
//           className={timeFrame === "12 months" ? "active" : ""}
//         >
//           12 months
//         </button>
//         <button
//           onClick={() => handleFilterClick("3 months")}
//           className={timeFrame === "3 months" ? "active" : ""}
//         >
//           3 months
//         </button>
//         <button
//           onClick={() => handleFilterClick("30 days")}
//           className={timeFrame === "30 days" ? "active" : ""}
//         >
//           30 days
//         </button>
//         <button
//           onClick={() => handleFilterClick("7 days")}
//           className={timeFrame === "7 days" ? "active" : ""}
//         >
//           7 days
//         </button>
//       </div>

//       {isLoading ? (
//         <><Card className="p-3 skeleton-card">
//           <div className="graph-skeleton">
//             <div className="bar bar-1"></div>
//             <div className="bar bar-2"></div>
//             <div className="bar bar-3"></div>
//             <div className="bar bar-4"></div>
//             <div className="bar bar-1"></div>
//             <div className="bar bar-2"></div>
//             <div className="bar bar-3"></div>
//             <div className="bar bar-4"></div>
//             <div className="bar bar-1"></div>
//             <div className="bar bar-2"></div>
//             <div className="bar bar-3"></div>
//             <div className="bar bar-4"></div>
//             <div className="bar bar-1"></div>
//             <div className="bar bar-2"></div>
//             <div className="bar bar-3"></div>
//             <div className="bar bar-4"></div>
//           </div>
//         </Card></>
//       ) : error ? (
//         <Alert variant="danger">Error loading data</Alert>
//       ) : (
//         <Chart
//           className="chartstyles"
//           chartType="LineChart"
//           data={graphData}
//           options={{
//             title: `Sales Data for ${timeFrame}`,
//             hAxis: {
//               title:
//                 timeFrame === "12 months" || timeFrame === "3 months"
//                   ? "Month"
//                   : timeFrame === "24 hours"
//                     ? "Hour"
//                     : timeFrame === "30 days"
//                       ? "Past Four Weeks"
//                       : "Date",
//               ...(timeFrame === "30 days" && {
//                 showTextEvery: 7,
//                 gridlines: { count: 5 },
//               }),
//             },
//             vAxis: { title: "Total Sales" },
//             legend: { position: "none" },
//             tooltip: { isHtml: true },
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default Graph;
import React, { useState, useEffect, useMemo } from "react";
import { Chart } from "react-google-charts";
import "./index.css";
import { useGetSalesDataForRestaurantQuery } from "../../redux/services/dashboardService";
import { useSelector } from "react-redux";
import { Alert, Card } from "react-bootstrap";

type ChartDataRow =
  | string
  | number
  | { role: string; type: string }
  | { v: string; f: string };

const today = new Date();

// Function to get the last day of the current month
const getEndOfMonth = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

// Calculate the start date for the timeframe
const calculateStartDate = (timeFrame: string): string => {
  const startDate = new Date(today);
  switch (timeFrame) {
    case "12 months":
      startDate.setMonth(today.getMonth() - 11); // Start 11 months ago to include current month
      startDate.setDate(1); // Set to the first day of the start month
      break;
    case "3 months":
      startDate.setMonth(today.getMonth() - 2);
      startDate.setDate(1);
      break;
    case "30 days":
      startDate.setDate(today.getDate() - 30);
      break;
    case "7 days":
      startDate.setDate(today.getDate() - 7);
      break;
    case "24 hours":
      startDate.setHours(0, 0, 0, 0);
      break;
    default:
      startDate.setMonth(today.getMonth() - 11);
      startDate.setDate(1);
  }
  return startDate.toISOString();
};

// Generate an array of hours from 00:00 to the current hour in ascending order
const generateHourRange = (now: Date): string[] => {
  const hourRange: string[] = [];
  const currentHour = now.getHours();

  for (let i = 0; i <= currentHour; i++) {
    const date = new Date(now);
    date.setHours(i, 0, 0, 0); // Set to the exact hour
    const hourLabel = date.toLocaleTimeString("default", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    hourRange.push(hourLabel); // e.g., "14:00"
  }

  return hourRange;
};

// Generate an array of dates for the past 30 days
const generateDateRange = (days: number): string[] => {
  const dateRange: string[] = [];
  for (let i = 0; i < days; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    dateRange.unshift(
      date.toLocaleDateString("default", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    );
  }
  return dateRange;
};

// Generate an array of month names for the past 12 months
const generateMonthNames = (months: number): string[] => {
  const monthNames: string[] = [];
  const endMonth = getEndOfMonth(today);
  for (let i = 0; i < months; i++) {
    const month = new Date(endMonth.getFullYear(), endMonth.getMonth() - i, 1);
    monthNames.unshift(
      month.toLocaleString("default", { month: "long", year: "numeric" })
    );
  }
  return monthNames;
};

const Graph = () => {
  const restaurantId = useSelector(
    (state: any) => state?.restaurant?.selectedRestaurantDetails?.id || "jdfhfhdf"
  );

  const [timeFrame, setTimeFrame] = useState("12 months");
  const [graphData, setGraphData] = useState<ChartDataRow[][]>([
    ["Date", "Total Sales"],
  ]);

  // Memoize `now` to avoid recreating it on every render
  const now = useMemo(() => new Date(), []);

  // Fetch sales data using RTK query hook
  const { data, error, isLoading } = useGetSalesDataForRestaurantQuery({
    restaurantId,
    startDate: calculateStartDate(timeFrame),
    endDate: today.toISOString(),
  });

  // Effect to handle data transformation
  useEffect(() => {
    if (data && data.salesStatList) {
      let formattedData: ChartDataRow[][] = [];

      if (timeFrame === "12 months" || timeFrame === "3 months") {
        // Handle month-based graph
        const monthsToGenerate = timeFrame === "12 months" ? 12 : 3;
        const monthNames = generateMonthNames(monthsToGenerate);

        // Initialize each month with a total of 0
        const salesByMonth: Record<string, number> = monthNames.reduce(
          (acc, month) => {
            acc[month] = 0;
            return acc;
          },
          {} as Record<string, number>
        );

        // Group and sum sales data by month
        data.salesStatList.forEach((sale) => {
          const saleMonth = new Date(sale.date).toLocaleString("default", {
            month: "long",
            year: "numeric",
          });
          if (salesByMonth[saleMonth] !== undefined) {
            salesByMonth[saleMonth] += sale.totalSales;
          }
        });

        // Format the data for the chart
        formattedData = monthNames.map((month) => [month, salesByMonth[month]]);
        setGraphData([["Month", "Total Sales"], ...formattedData]);
      }

      if (timeFrame === "30 days") {
        const dateRange = generateDateRange(30); // Individual dates for last 30 days

        // Initialize each date with a total of 0
        const salesByDate: Record<string, number> = dateRange.reduce((acc, date) => {
          acc[date] = 0;
          return acc;
        }, {} as Record<string, number>);

        // Group and sum sales data by day
        data.salesStatList.forEach((sale) => {
          const saleDate = new Date(sale.date).toLocaleDateString("default", {
            day: "numeric",
            month: "short",
            year: "numeric",
          });
          if (salesByDate[saleDate] !== undefined) {
            salesByDate[saleDate] += sale.totalSales;
          }
        });

        // Format the data for the chart
        formattedData = dateRange.map((date, index) => {
          const totalSales = salesByDate[date];
          const showLabel = index % 7 === 0; // Show label only for every 7th day

          // Create a tooltip content
          const tooltipContent = `Date: ${date}\nTotal Sales: ${totalSales}`;

          return [
            { v: date, f: showLabel ? date : "" },
            totalSales,
            tooltipContent
          ];
        });

        setGraphData([
          ["Date", "Total Sales", { role: "tooltip", type: "string" }],
          ...formattedData
        ]);
      }

      if (timeFrame === "7 days") {
        // Handle day-based graph
        const daysToGenerate = 7;
        const dateRange = generateDateRange(daysToGenerate);

        // Initialize each day with a total of 0
        const salesByDay: Record<string, number> = dateRange.reduce(
          (acc, date) => {
            acc[date] = 0;
            return acc;
          },
          {} as Record<string, number>
        );

        // Group and sum sales data by day
        data.salesStatList.forEach((sale) => {
          const saleDate = new Date(sale.date).toLocaleDateString("default", {
            day: "numeric",
            month: "short",
            year: "numeric",
          });
          if (salesByDay[saleDate] !== undefined) {
            salesByDay[saleDate] += sale.totalSales;
          }
        });

        // Format the data for the chart
        formattedData = dateRange.map((date) => [date, salesByDay[date]]);
        setGraphData([["Date", "Total Sales"], ...formattedData]);
      }

      if (timeFrame === "24 hours") {
        // Handle hour-based graph
        const hourRange = generateHourRange(now); // Generate hours from 00:00 to current hour

        // Initialize each hour with a total of 0
        const salesByHour: Record<string, number> = hourRange.reduce(
          (acc, hour) => {
            acc[hour] = 0;
            return acc;
          },
          {} as Record<string, number>
        );

        // Group and sum sales data by hour
        data.salesStatList.forEach((sale) => {
          const saleDate = new Date(sale.date);
          const saleHour = saleDate.toLocaleTimeString("default", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });
          if (salesByHour[saleHour] !== undefined) {
            salesByHour[saleHour] += sale.totalSales;
          }
        });

        // Format the data for the chart
        formattedData = hourRange.map((hour) => [hour, salesByHour[hour]]);
        setGraphData([["Hour", "Total Sales"], ...formattedData]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, timeFrame]); // Removed `now` from dependencies

  // Function to handle filter button click
  const handleFilterClick = (selectedTimeFrame: string) => {
    setTimeFrame(selectedTimeFrame);
  };

  return (
    <div>
      <div className="filter-buttons">
        <button
          onClick={() => handleFilterClick("12 months")}
          className={timeFrame === "12 months" ? "active" : ""}
        >
          12 months
        </button>
        <button
          onClick={() => handleFilterClick("3 months")}
          className={timeFrame === "3 months" ? "active" : ""}
        >
          3 months
        </button>
        <button
          onClick={() => handleFilterClick("30 days")}
          className={timeFrame === "30 days" ? "active" : ""}
        >
          30 days
        </button>
        <button
          onClick={() => handleFilterClick("7 days")}
          className={timeFrame === "7 days" ? "active" : ""}
        >
          7 days
        </button>
      </div>

      {isLoading ? (
        <><Card className="p-3 skeleton-card">
          <div className="graph-skeleton">
            <div className="bar bar-1"></div>
            <div className="bar bar-2"></div>
            <div className="bar bar-3"></div>
            <div className="bar bar-4"></div>
            <div className="bar bar-1"></div>
            <div className="bar bar-2"></div>
            <div className="bar bar-3"></div>
            <div className="bar bar-4"></div>
            <div className="bar bar-1"></div>
            <div className="bar bar-2"></div>
            <div className="bar bar-3"></div>
            <div className="bar bar-4"></div>
            <div className="bar bar-1"></div>
            <div className="bar bar-2"></div>
            <div className="bar bar-3"></div>
            <div className="bar bar-4"></div>
          </div>
        </Card></>
      ) : error ? (
        <Alert variant="danger">Error loading data</Alert>
      ) : (
        <Chart
          className="chartstyles"
          chartType="LineChart"
          data={graphData}
          options={{
            title: `Sales Data for ${timeFrame}`,
            hAxis: {
              title:
                timeFrame === "12 months" || timeFrame === "3 months"
                  ? "Month"
                  : timeFrame === "24 hours"
                    ? "Hour"
                    : timeFrame === "30 days"
                      ? "Past Four Weeks"
                      : "Date",
              ...(timeFrame === "30 days" && {
                showTextEvery: 7,
                gridlines: { count: 5 },
              }),
            },
            vAxis: { title: "Total Sales" },
            legend: { position: "none" },
            tooltip: { isHtml: true },
          }}
        />
      )}
    </div>
  );
};

export default Graph;
